module.exports = __webpack_public_path__ + "static/img/stay-option-icon-tv.f57646c2.svg";